// extracted by mini-css-extract-plugin
export var container = "_4i-0";
export var fallback = "_4i-5";
export var fallbackIcon = "_4i-6";
export var hidden = "_4i-2";
export var image = "_4i-3";
export var loaded = "_4i-4";
export var placeholder = "_4i-1";